import React, { useState } from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
//import { Sidebar } from "../components/Sidebar";
//import { Light, Dark } from "../styles/Themes";
//import styled from "styled-components";
//import { ThemeProvider } from "styled-components";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "../context/AuthProvider";
//import { Col, Container, Row } from "react-bootstrap";

export const ThemeContext = React.createContext(null);

const RequireAuth = ({ allowedRoles }) => {
  const { auth } = useAuth();
  const location = useLocation();
  //const [theme, setTheme] = useState("Dark");
  //const themeStyle = theme === "light" ? Light : Dark;

  //const [sidebarOpen, setSidebaropen] = useState(true);
//console.log(auth);
  return auth?.roles?.find((role) => allowedRoles?.includes(role)) ? (
    <>
      {" "}
      {auth ? (
        <>
          <AuthProvider>
            <>
              {/* <Container className={sidebarOpen ? "sidebarState active" : ""}>  */}
              {/* <Row className="MainRow "> */}
                {/* <Col md="4" lg="3" xl="4" xxl="2"> */}
                {/* <Sidebar
                  sidebarOpen={sidebarOpen}
                  setSidebaropen={setSidebaropen}
                /> */}
                {/* </Col> */}
                {/* <Col  md="8" lg="9" xl="8" xxl="10"> */}
                <Outlet />
                {/* </Col> */}
              {/* </Row> */}
              {/* </Container> */}
            </>
          </AuthProvider>
        </>
      ) : (
        <>
          {" "}
          <Outlet />{" "}
        </>
      )}{" "}
    </>
  ) : auth?.user ? (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};
export default RequireAuth;
